<template>
  <div
    class="form-group"
    :class="{ 'has-error': hasErrors, 'has-success': isValid }"
  >
    <label
      :for="id"
      :class="{
        required: validator.$params['required'],
        heading: labelType === 'heading'
      }"
    >
      {{ label }}
    </label>
    <slot />
    <div class="errors" v-if="hasErrors">
      <div class="error" v-for="error in activeErrorMessages" :key="error">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
  import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

  export default {
    name: "FormGroup",
    mixins: [singleErrorExtractorMixin],
    props: {
      id: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      labelType: {
        type: String
      }
    }
  };
</script>

<style lang="scss">
  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    label {
      font-weight: $font-semibold;
      padding-bottom: 5px;

      &.required:after {
        content: "*";
        color: $color-error;
      }

      &.heading {
        font-size: 16px;
      }
    }

    input {
      width: 100%;
      box-sizing: border-box;
    }

    .error {
      color: $color-error;
    }

    &.has-error {
      label {
        color: $color-error;
      }

      input {
        border-color: $color-error;
      }
    }
  }
</style>
